import axios from "axios";
import { Component, createRef } from "react";
import settings from "../settings";
import backArrow from "../images/back_arrow.png";
import posterPlaceholder from "../images/poster-placeholder.jpg";

class TVSeason extends Component{
    constructor(props){
        super(props);
        this.state = {
            episodes: []
        }
        this.castPanel = createRef(null);
    }

    componentDidMount = () => {
        const url = `${settings.api_url}api/details/tv/season?itemID=${this.props.itemID}&season=${this.props.season}`;
        axios.get(url)
        .then(data => {
            this.focusPanel();
            this.setState({
                episodes: data.data
            });
        });
    }

    componentDidUpdate = (oldProps) => {
        if((oldProps.itemID !== this.props.itemID) ||
            (oldProps.season !== this.props.season)){
                const url = `${settings.api_url}api/details/tv/season?itemID=${this.props.itemID}&season=${this.props.season}`;
                axios.get(url)
                .then(data => {
                    this.setState({
                        episodes: data.data
                    });
                });        
            }
    }

    scroll = (rl) => {
        let panelWidth = this.castPanel?.current?.clientWidth;
        let scrollWidth = this.castPanel?.current?.scrollWidth;

        if(rl === 'r'){
            if(this.castPanel.current.lastChild.offsetLeft+419 > this.scrollPos+panelWidth){
                if(this.scrollPos === 0)
                    this.scrollPos = this.scrollPos += 432;
                else
                    this.scrollPos = this.scrollPos += 419;
            }
        }
        if(rl === 'l'){
            this.scrollPos = this.scrollPos-419<0?0:this.scrollPos -= 419;
        }
        this.castPanel.current.scroll({left:this.scrollPos,behavior: "smooth"});

    }
    
    focusPanel = () => {
        this.castPanel.current.focus();
    }

    processKey = (e) => {
        if(e.key === "ArrowRight"){
            this.scroll("r");
        }
        if(e.key === "ArrowLeft"){
            this.scroll("l");
        }
    }

    render = () => {
        const backbuttonStyle = {
            width: "20px",
            height: "20px",
            display: "inline-block",
            cursor: "pointer"
        }
        const seasonName = typeof this.props.seasonName === "undefined"?"":this.props.seasonName;
        let imageBaseURL = "https://image.tmdb.org/t/p/w500";
        const posterStyle = {
            objectFit: "contain"
        }

        if(this.state.episodes)

        return (//tvseasons-div
            <div className="cast-panel" ref={this.castPanel}>
                <div className="tv-episode">
                    <div style={{display:"flex",flexDirection:"column", justifyContent: "flex-start", width: "100%"}}>
                        <div onClick={this.props.backToSeasons} style={{flex:"0 0 100%"}}>
                            <img src={backArrow} alt="back arrow" style={backbuttonStyle}/>
                        </div>
                        <div onClick={this.props.backToSeasons} style={{color: "orange", marginLeft: "1em", cursor: "pointer"}}> Back to seasons</div>
                    </div>
                    <h3 style={{marginTop: "0", marginBottom: "0"}}>{this.state.episodes.name}</h3>
                </div>
                {
                    typeof this.state.episodes.episodes !== "undefined"?this.state.episodes.episodes.map((item,si) => {
                        return(
                        <div className="tv-episode">
                        <a href={`?page=details&itemType=episode&itemID=${this.props.itemID}&season=${this.props.season}&episode=${item.episode_number}&series=${this.props.seriesName}`}>
                            <div data-episode={item.episode_number} data-season={seasonName} className="tv-episode-container summary-small-size" key={`seasons-div1-${si}`}>
                            <div style={posterStyle} key={`seasons-div2-${si}`}>
                                <div style={posterStyle} key={`seasons-div3-${si}`} data-season={item.episode_number} className="small-poster-div" >
                                    <img className="tv-episode-still" style={posterStyle} key={`seasons-img1-${si}`} data-season={item.episode_number} src={item.still_path!==null?imageBaseURL+item.still_path:posterPlaceholder} alt="season poster" loading="lazy"/>
                                </div>
                                <div className="small-media-title" key={`seasons-div4-${si}`} data-season={item.episode_number} >
                                    <div>{item.name}</div>
                                <div key={`seasons-div5-${si}`} data-episode={item.episode_number} >{item.overview.substr(0,65)}{item.overview.length > 65?"...":""}</div><br />
                                <div key={`seasons-div7-${si}`} data-episode={item.episode_number} >{item.air_date!==null?`Aired on ${item.air_date}`:""}</div></div>                                    
                            </div>
                            </div></a>
                            </div>
                        );
                        }):<></>
                }
            </div>
        );
    }
}
export default TVSeason;